<template>
  <section class="pool-create mt-3">
    <h1>Market Create</h1>

    <div class="row mt-3">
      <div class="col-12 col-lg-8 mx-auto">
        <div class="card animate__animated animate__fadeIn">
          <div class="card-body">
            <div class="row mt-3">
              <div class="col"><label>Openbook ID:</label></div>
              <div class="col-auto">
                <AccountAddress
                  class="text-end"
                  :full="true"
                  :address="OPENBOOK_PROGRAM_ID()"
                ></AccountAddress>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col"><label>Select Tokens</label></div>
              <div class="col-auto">
                <TokenPicker
                  :token="form.tokenA"
                  @tokenChange="onTokenAChange"
                ></TokenPicker>
              </div>
              <div class="col-auto">
                <TokenPicker
                  :token="form.tokenB"
                  @tokenChange="onTokenBChange"
                ></TokenPicker>
              </div>
            </div>
            <div class="form-group mt-2">
              <label>Minimum order size:</label>
              <input v-model.number="form.orderSize" class="form-control" />
            </div>
            <div class="form-group mt-2">
              <label>Minimum price tick size:</label>
              <input v-model.number="form.tickSize" class="form-control" />
            </div>
          </div>
          <div class="card-footer">
            <button class="btn btn-solid-primary w-100 mt-3">
              Create Market
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TokenPicker from "@/components/token/TokenPicker.vue";
import AccountAddress from "@/components/common/AccountAddress.vue";
import { OPENBOOK_PROGRAM_ID } from "@/api/token_swap/constants";

export default {
  name: "MarketCreate",
  components: { AccountAddress, TokenPicker },
  data() {
    return {
      form: {
        tokenA: null,
        tokenB: null,
        orderSize: 1,
        tickSize: 0.01,
      },
    };
  },
  methods: {
    OPENBOOK_PROGRAM_ID() {
      return OPENBOOK_PROGRAM_ID;
    },
    onTokenAChange: function (token) {
      this.form.tokenA = token;
    },
    onTokenBChange: function (token) {
      this.form.tokenB = token;
    },
  },
};
</script>

<style scoped></style>
